export const COLORS = [
  { id: 'red', zh: '红', en: 'RED', hex: '#d72b1f', textOn: '#fff6ec', symbol: '●' },
  { id: 'blue', zh: '蓝', en: 'BLUE', hex: '#1e55c8', textOn: '#f5f2e8', symbol: '▲' },
  { id: 'green', zh: '绿', en: 'GREEN', hex: '#1e7d46', textOn: '#f5f2e8', symbol: '■' },
  { id: 'yellow', zh: '黄', en: 'YELLOW', hex: '#e0b000', textOn: '#15140f', symbol: '◆' },
  { id: 'purple', zh: '紫', en: 'PURPLE', hex: '#7d3bc9', textOn: '#f5f2e8', symbol: '★' },
  { id: 'orange', zh: '橙', en: 'ORANGE', hex: '#e36516', textOn: '#15140f', symbol: '✚' },
  { id: 'black', zh: '黑', en: 'BLACK', hex: '#12120f', textOn: '#f5f2e8', symbol: '▼' },
  { id: 'white', zh: '白', en: 'WHITE', hex: '#f2eee1', textOn: '#15140f', symbol: '○' },
] as const;

export type ColorId = (typeof COLORS)[number]['id'];

export interface ColorDef {
  id: ColorId;
  zh: string;
  en: string;
  hex: string;
  textOn: string;
  symbol: string;
}

export const ALL_COLOR_IDS: readonly ColorId[] = COLORS.map((color) => color.id);

export const COLOR_BY_ID: Record<ColorId, ColorDef> = {
  red: COLORS[0],
  blue: COLORS[1],
  green: COLORS[2],
  yellow: COLORS[3],
  purple: COLORS[4],
  orange: COLORS[5],
  black: COLORS[6],
  white: COLORS[7],
};

export function colorName(id: ColorId, language: 'zh' | 'en'): string {
  const color = COLOR_BY_ID[id];
  return language === 'zh' ? `${color.zh}色` : color.en;
}

export function isColorId(value: unknown): value is ColorId {
  return typeof value === 'string' && value in COLOR_BY_ID;
}
